import React from "react"
import { useState, useEffect } from "react"
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  FormControl,
  IconButton,
  Stack,
  Autocomplete,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Checkbox,
  Pagination,
  Popover,
  List,
  ListItem,
  ListItemText,
  DialogActions,
  ListItemIcon,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import "react-datepicker/dist/react-datepicker.css"
import {
  ApiGetAllocations,
  ApiGetVisitTimes,
  ApiGetVenueList,
  ApiGetAppliedAllocations,
  ApiPostUpdateAppliedAllocationStatus,
  ApiGetClientEntityByClientGroupId,
  ApiGetShopperPopUpDetails,
  ApiGetApproveAllocationShopper,
  ApiGetAllocationCriteriaDetails,
  ApiGetAppliedBundleAllocations,
  ApiGetBundleList,
  ApiGetBundleAllocations,
  ApiPostUpdateBundleAppliedAllocationStatus,
  ApiHoldAppliedAllocation,
  ApiHoldBundleAppliedAllocation,
} from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"
import useDebounce from "../CreateAllocations/UseDebounce.tsx"
import { useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import Dcrage from "../OrphanAllocation/Dcrage.tsx"
import { Close, Warning, Error } from "@mui/icons-material"
import dayjs, { type Dayjs } from "dayjs"

interface JobAllocation {
  id: number
  name: string
  address: string
  postalCode: string
  TradeHouse: string
  webSite: string
}

export default function ApproveAllocation() {
  const [currentDate, setCurrentDate] = useState(new Date())
  const [allocations, setAllocations] = useState<JobAllocation[]>([])
  const [visitTimes, setVisitTimes] = useState<any>([])
  const [venueName, setVenueName] = useState<any>([])
  const [venueNameValue, setVenueNameValue] = useState<any>(null)
  const [clientEntityList, setClientEntityList] = useState<any>([])
  const [clientEntityId, setClientEntityId] = useState<string | null>(null)
  const [appliedAllocation, setAppliedAllocation] = useState<any>([])
  const [groupappliedAllocation, setgroupAppliedAllocation] = useState<any>([])
  const debouncedClientEntityId = useDebounce(clientEntityId, 500)
  const debouncedVenue = useDebounce(venueNameValue, 700)

  // Updated pagination state
  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  const [selectedClient, setSelectedClient] = useState<any>(null)
  const [ClientId, setClientId] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const [loanData, setLoanData] = useState()
  const [datalength, setdatalength] = useState<any>()
  const [shoppers, setShoppers] = useState<any>([])
  const [allocationCriteria, setAllocationCriteria] = useState()
  const [openDialog, setOpenDialog] = useState(false)
  const [issueList, setIssueList] = useState<string[]>([])
  const [bundleList, setbundleList] = useState<any>([])
  const [selectedBundle, setSelectedBundle] = useState<any>()
  const [reasonforhold, setreasonforhold] = useState<any>()
  const [OpenHoldReason, setOpenHoldReason] = useState<boolean>(false)
  const [holdId, setholdId] = useState<number | string>()


  useEffect(() => {
    if (Clientlist.length > 2) {
      setSelectedClient(Clientlist[2])
      setClientId(Clientlist[2].clientGroupName)
    }
  }, [Clientlist])

  useEffect(() => {
    setreasonforhold('')
  }, [OpenHoldReason])

  // Updated pagination handler
  const handlePageChange = (event, value) => {
    // setCurrentPage(value)
    const jobMonth = currentDate.getMonth() + 1
    const jobYear = currentDate.getFullYear()
    handleGetAppliedAllocation(jobMonth, jobYear)
  }

  const handlePrevMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
      const jobMonth = newDate.getMonth() + 1
      const jobYear = newDate.getFullYear()
      // setCurrentPage(1) // Reset to first page when changing month
      handleGetAppliedAllocation(jobMonth, jobYear)
      return newDate
    })
  }

  useEffect(() => {
    // console.log("ClientId", ClientId)
    handleGetClientList()
  }, [ClientId])

  const handleHover = async (event, index, item?: any) => {
    setAnchorEl(event.currentTarget)
    try {
      const currentDate = new Date()
      const currentMonth = currentDate.getMonth() + 1
      const currentYear = currentDate.getFullYear()

      const data = `?userId=${item.userId.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`

      const response = await ApiGetShopperPopUpDetails(data)

      if (!response.status) {
        toast.error("Failed to load shopper details")
        return
      }

      if (response.data) {
        setLoanData(response.data)
      }
    } catch (error) {
      //toast.error("Error loading shopper details");
    }
  }

  const handlePopUpClose = () => {
    setAnchorEl(null)
  }

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${ClientId}`
    if (!ClientId) return
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data)
      // console.log(res.data)
      setClientEntityList(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const handleNextMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
      const jobMonth = newDate.getMonth() + 1
      const jobYear = newDate.getFullYear()
      // setCurrentPage(1) // Reset to first page when changing month
      handleGetAppliedAllocation(jobMonth, jobYear)
      return newDate
    })
  }

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = new Date(event.target.value + "-01")
    setCurrentDate(newDate)

    const jobMonth = newDate.getMonth() + 1
    const jobYear = newDate.getFullYear()
    // setCurrentPage(1) // Reset to first page when date changes
    handleGetAppliedAllocation(jobMonth, jobYear)
  }

  const formatDate = (date: Date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
  }

  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date()
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      //await ApiCallGetVenueList()
      await handleGetAppliedAllocation(jobMonth, jobYear)
      await handleGetClientList()
    }
    fetchData()
    return () => { }
  }, [debouncedVenue, clientEntityId])

  useEffect(() => {
    const fetchData = async () => {
      await handleGetVisitTimeList()
    }
    fetchData()
    return () => { }
  }, [appliedAllocation])

  const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
    const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500`
    const res = await ApiGetVenueList(data)
    const response = res?.data.map((item) => ({
      label: item.venueName,
      value: item.venueId,
    }))
    setVenueName(response)
  }

  const handleGetVisitTimeList = async (selectedVisitTime?: any) => {
    try {
      const response: any = await ApiGetVisitTimes()
      setVisitTimes(response?.data)
      // console.log("response star ", response?.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  useEffect(() => {
    if (debouncedClientEntityId) {
      ApiCallGetVenueList(debouncedClientEntityId)
    } else {
      setVenueName([])
      setVenueNameValue(null)
    }
  }, [debouncedClientEntityId])

  const [open, setOpen] = useState(false)

  const handleClickOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setIssueList([])
  }

  useEffect(() => {
    if (selectedClient) {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      // setCurrentPage(1) // Reset to first page when client changes
      handleGetAppliedAllocation(jobMonth, jobYear)
    }
  }, [selectedClient])

  // Updated handleGetAppliedAllocation with proper pagination
  const handleGetAppliedAllocation = async (jobMonth?: number, jobYear?: number,) => {
    // const offset = (page - 1) * itemsPerPage
    let data = `?offset=0&limit=100&allocationStatus=shopper_applied&jobMonth=${jobMonth}&jobYear=${jobYear}`

    if (venueNameValue) data += `&venueId=${venueNameValue}`
    if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
    if (selectedClient?.clientGroupName) data += `&allocationClientGroup=${selectedClient.clientGroupName}`

    if (selectedClient?.clientGroupName) {
      try {
        const res: any = await ApiGetAllocations(data)
        setdatalength(res.totalDataCount)
        setAllocations(res.data)

        // Set total count from API response for pagination
        if (res.totalDataCount !== undefined) {
          // setTotalCount(res.totalDataCount)
        }
      } catch (error) {
        console.error("Error during API call:", error)
      }
    }
  }

  // console.log(allocations)

  const handleGetShopperAppliedAllocation = async (allocation: any) => {
    const data = `?offset=0&limit=10&allocationStatus=shopper_applied&allocationId=${allocation.allocationId}`
    try {
      const res: any = await ApiGetAppliedAllocations(data)
      setAppliedAllocation(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }
  const handleGetShopperAppliedBundleAllocation = async (allocation: any) => {
    const data = `?offset=0&limit=100&allocationStatus=applied&bundleId=${allocation.bundleId}`
    try {
      const res: any = await ApiGetAppliedBundleAllocations(data)
      setAppliedAllocation(res.data[0])
      console.log("Total Item", res.data[0].appliedAllocations)
      const groupedArray: any = [];

      res.data[0].appliedAllocations.forEach(item => {
        const existing = groupedArray.find(entry => entry.userId === item.userId.userId);
        if (existing) {
          existing.data.push(item);
        } else {
          groupedArray.push({
            userId: item.userId.userId,
            data: [item]
          });
        }
      });
      setgroupAppliedAllocation(groupedArray)

    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const handleGetApproveAllocationShopper = async (allocation: any) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const data = `?venueId=${allocation?.venueId?.venueId}&jobMonth=${currentMonth}&jobYear=${currentYear}`
    try {
      const res: any = await ApiGetApproveAllocationShopper(data)
      setShoppers(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  // console.log(appliedAllocation)

  const handleUpdateAppliedAllocation = async (shopperApplied, status) => {
    const data = {
      userId: shopperApplied.userId.userId,
      allocationId: shopperApplied.allocationId.allocationId,
      status: status,
      modifiedBy: Number(localStorage.getItem("createdBy")),
    }
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiPostUpdateAppliedAllocationStatus(data)
      handleClose()
      toast.success("Allocation Approved successfully")
      handleGetAppliedAllocation(jobMonth, jobYear)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }
  const handleHoldAppliedAllocation = async (shopperApplied) => {

    const data1 = `?userId=${shopperApplied.userId.userId}&allocationId=${shopperApplied.allocationId.allocationId}`
    const data2 = {
      holdReason: reasonforhold,
      isHold: true,
      holdById: Number(localStorage.getItem("createdBy")),
    }
    console.log("Data1", data1)
    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiHoldAppliedAllocation(data1, data2)
      handleClose()
      toast.success("Allocation Hold successfully")
      handleGetAppliedAllocation(jobMonth, jobYear)
    } catch (error) {
      console.error("Error during API call:", error)
    }
    finally { setreasonforhold(''); setOpenHoldReason(false); }
  }
  const handleHoldBundleAppliedAllocation = async (bundleId, userId) => {

    const data1 = `?userId=${userId}&bundleId=${bundleId}`
    const data2 = {
      holdReason: reasonforhold,
      isHold: true,
      holdById: Number(localStorage.getItem("createdBy")),
    }
    console.log("Data1", data1)

    try {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      const res: any = await ApiHoldBundleAppliedAllocation(data1, data2)
      handleClose()
      toast.success("Allocation Approved successfully")
      GetBundleAllocations()
    } catch (error) {
      console.error("Error during API call:", error)
    }
    finally { setreasonforhold(''); setOpenHoldReason(false); }
  }
  // console.log("Applied allocation", appliedAllocation)
  const handleUpdateBundleAppliedAllocation = async (bundleId, userId, status) => {
    const data = {
      userId: userId,
      bundleId: bundleId,
      status: status,
      modifiedBy: Number(localStorage.getItem("createdBy")),
    }
    console.log("Send Approve Data", data)
    try {

      const res: any = await ApiPostUpdateBundleAppliedAllocationStatus(data)
      handleClose()
      toast.success("Bundle Allocation Approved successfully")
      GetBundleAllocations()
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const handelInvite = (stateData: any) => {
    sessionStorage.setItem("inviteShopperState", JSON.stringify(stateData))
    const url = `/admin/allocations/Invite-Shopper`
    window.open(url, "_blank")
  }

  const handleGetAllocationCriteria = async (shopperApplied: any) => {
    // console.log(shopperApplied)
    const data = `?allocationId=${shopperApplied.allocationId}&clientEntityId=${shopperApplied.venueId.clientEntityId.clientEntityId}`
    const response = await ApiGetAllocationCriteriaDetails(data)
    setAllocationCriteria(response.data)
  }

  // console.log(allocationCriteria)

  const handleIconClick = (shopperApplied: any) => {
    const issues = getIssuesFromAllocationCriteria(allocationCriteria, shopperApplied.selectedVisitDate)
    setIssueList(issues)
    setOpenDialog(true)
  }

  const getIssuesFromAllocationCriteria = (allocationCriteria: any, selectedDateInput: Dayjs | string): string[] => {
    const issues: string[] = []

    const selectedDate = dayjs(selectedDateInput)
    const lastJobDate = allocationCriteria?.lastJobVisitedDate ? dayjs(allocationCriteria.lastJobVisitedDate) : null

    if (allocationCriteria?.shouldBeDifferentDayFromPreviousMonth && lastJobDate) {
      if (selectedDate.format("dddd") === lastJobDate.format("dddd")) {
        issues.push("Selected day is the same weekday as the previous month's job date.")
      }
    }

    const minGap = allocationCriteria?.minDaysGapBetweenJobs
    if (minGap && lastJobDate) {
      const nextValidDate = lastJobDate.add(minGap, "day")
      if (selectedDate.isBefore(nextValidDate, "day")) {
        issues.push(
          `Selected date must be at least ${minGap} day(s) after the last visit (${lastJobDate.format("DD-MM-YYYY")}).`,
        )
      }
    }

    return issues
  }

  useEffect(() => {

    const GetBundleList = async () => {
      // const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
      try {
        const res = await ApiGetBundleList()
        setbundleList(res.data)
        setSelectedBundle(null)

      } catch (error) {
        alert(error)
      }
    }
    GetBundleList()
  }, [currentDate])
  const GetBundleAllocations = async () => {
    if (selectedBundle) {
      const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&bundleId=${selectedBundle?.bundleId}&allocationStatus=shopper_applied`
      try {
        const res = await ApiGetBundleAllocations(data)
        setAllocations(res.data)

      } catch (error) {
        alert(error)
      }
    }

  }
  useEffect(() => {

    GetBundleAllocations()
    // console.log("Selected Bundle ", selectedBundle);

  }, [selectedBundle])
  console.log('Group ALlocation',groupappliedAllocation)
  return (
    <div>
      <Box sx={{ p: 4 }} style={{ background: "white" }}>
        <Stack spacing={3}>
          <Box sx={{ width: "100%" }}>
            <h1 className="common-manage-h1" style={{ textAlign: "center" }}>
              Approve Allocation
            </h1>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "-70px",
                marginTop: "23px",
              }}
            >
              <Stack direction="row" spacing={2}>
                <FormControl size="small" sx={{ width: 180 }}>
                  <Autocomplete
                    disablePortal
                    id="beacon-autocomplete"
                    options={clientEntityList.filter((item) => item.clientEntityId !== null)}
                    getOptionLabel={(option) => option?.entityName || ""}
                    onChange={(event, newValue: any) => {
                      setClientEntityId(newValue?.clientEntityId || null)
                      if (!newValue) {
                        setVenueNameValue(null)
                      }
                    }}
                    value={clientEntityList.find((option) => option?.clientEntityId === clientEntityId) || null}
                    renderInput={(params) => <TextField {...params} label="Select Business" />}
                    size="small"
                  />
                </FormControl>
                <FormControl size="small" sx={{ width: 180 }}>
                  <Autocomplete
                    disablePortal
                    id="mm-autocomplete"
                    options={venueName}
                    value={venueName.find((option) => option.value === venueNameValue) || null}
                    onChange={(event, newValue) => {
                      setVenueNameValue(newValue?.value)
                    }}
                    defaultValue=""
                    renderInput={(params) => <TextField {...params} label="Search Venue" />}
                    size="small"
                  />
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={2}>
                <FormControl size="small" sx={{ width: 300 }}>
                  <Autocomplete
                    disablePortal
                    id="mm-autocomplete"
                    options={bundleList}
                    value={selectedBundle || null}
                    getOptionLabel={(option) => option?.bundleName}
                    isOptionEqualToValue={(option, value) => option.bundleId === value.bundleId}
                    onChange={(event, newValue: any) => {
                      setSelectedBundle(newValue)
                    }}
                    // defaultValue=
                    renderInput={(params) => <TextField {...params} label="Select Bundle" />}
                    size="small"
                  />
                </FormControl>
                <FormControl size="small" sx={{ width: 180 }}>
                  <Autocomplete
                    disablePortal
                    id="mm-autocomplete"
                    options={Clientlist}
                    value={selectedClient}
                    getOptionLabel={(option) => option?.clientGroupName}
                    isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                    onChange={(event, newValue: any) => {
                      setSelectedClient(newValue)
                      setClientId(newValue?.clientGroupName || null)
                      if (
                        !newValue ||
                        (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)
                      ) {
                        setClientEntityId(null)
                        setVenueNameValue(null)
                        setClientEntityList([])
                      }
                    }}
                    renderInput={(params) => <TextField {...params} label="Select Client" />}
                    size="small"
                  />
                </FormControl>
              </Stack>

            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "70px",
            }}
          >
            <IconButton onClick={handlePrevMonth}>
              <ChevronLeftIcon />
            </IconButton>
            <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
              <input
                type="month"
                value={formatDate(currentDate)}
                onChange={handleDateChange}
                className="primary-color"
                style={{
                  border: "none",
                  background: "none",
                  fontSize: "1.25rem",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              />
            </Box>
            <IconButton onClick={handleNextMonth}>
              <ChevronRightIcon />
            </IconButton>
          </Box>

          <Grid
            container
            spacing={4}
            className="mt-5"
            style={{
              gap: "20px",
              paddingRight: "32px",
              flexWrap: "nowrap",
              gridTemplateColumns: "2fr 2fr",
              display: "grid",
            }}
          >
            {(!selectedBundle && allocations.length > 0) && allocations?.map((allocation: any, index) => (
              <Grid
                style={{
                  padding: "0px",
                  boxShadow: "none",
                  maxWidth: "100%",
                  width: "100%",
                }}
                item
                xs={12}
                md={6}
                key={index}
              >
                <Card className="min-border-color" style={{ boxShadow: "none" }} sx={{ padding: "16px" }}>
                  <CardContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        <Typography variant="h6" gutterBottom>
                          {allocation?.venueId?.venueName}
                        </Typography>
                        <Typography>
                          {" "}
                          <b>Address:</b> {allocation?.venueId?.address}
                        </Typography>
                        <Typography>
                          <b>Postcode:</b> {allocation?.venueId?.postalCode}
                        </Typography>
                        <Typography>
                          <b>Trade House:</b> {allocation?.venueId?.tradingHours}
                        </Typography>
                        <Typography>
                          <b>WebSite:</b> {allocation?.venueId?.websiteURL}
                        </Typography>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "16px",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ marginBottom: "8px", width: "170px" }}
                          onClick={() => {
                            handleGetVisitTimeList(allocation)
                            handleGetShopperAppliedAllocation(allocation)
                            handleClickOpen()
                            handleGetApproveAllocationShopper(allocation)
                            handleGetAllocationCriteria(allocation)
                          }}
                        >
                          View Applications
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ width: "170px" }}
                          onClick={() => handelInvite(allocation)}
                        >
                          Invite Shopper
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            {selectedBundle && allocations?.map((Item: any, index) => (
              <Grid
                style={{
                  padding: "0px",
                  boxShadow: "none",
                  maxWidth: "100%",
                  width: "100%",
                }}
                item
                xs={12}
                md={6}
                key={index}
              >
                <Card className="min-border-color" style={{ boxShadow: "none" }} sx={{ padding: "16px" }}>
                  <CardContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        <Typography variant="h6" gutterBottom>
                          {Item?.bundleName}
                        </Typography>
                        {/* <Typography>
                          {" "}
                          <b>Address:</b> {allocation?.venueId?.address}
                        </Typography>
                        <Typography>
                          <b>Postcode:</b> {allocation?.venueId.postalCode}
                        </Typography>
                        <Typography>
                          <b>Trade House:</b> {allocation?.venueId.tradingHours}
                        </Typography>
                        <Typography>
                          <b>WebSite:</b> {allocation?.venueId.websiteURL}
                        </Typography> */}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "16px",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ marginBottom: "8px", width: "170px" }}
                          onClick={() => {
                            // handleGetVisitTimeList(allocation)
                            handleGetShopperAppliedBundleAllocation(Item)
                            handleClickOpen()
                            // handleGetApproveAllocationShopper(allocation)
                            // handleGetAllocationCriteria(allocation)
                          }}
                        >
                          View Applications
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ width: "170px" }}
                        // onClick={() => handelInvite(allocation)}
                        >
                          Invite Shopper
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Stack>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handlePopUpClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {loanData ? <Dcrage handleClose={handleClose} loanData={loanData} /> : null}
        </Popover>

        <Dialog className="ApproveAllocation" open={open} onClose={handleClose}>
          <DialogContent className="dialog-content">
            <div
              style={{
                display: "flex ",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <DialogTitle className="dialog-title">Approve applications</DialogTitle>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              >
                X
              </div>
            </div>

            <div style={{ display: "flex" }}>
              <div className="previous-shoppers table-row-background">
                <h2 className="previous-shoppers__title">Previous Shoppers</h2>

                <div className="previous-shoppers__grid">
                  {shoppers?.previousMonth?.map((shopper, index) => (
                    <div className="previous-shoppers__item" key={index}>
                      <div className="previous-shoppers__month">{`${shopper?.month} - ${shopper?.year}`}</div>
                      <div className="previous-shoppers__name">{shopper?.shopperUsername}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="previous-shoppers table-row-background">
                <h2 className="previous-shoppers__title">Future Shoppers</h2>

                <div className="previous-shoppers__grid">
                  {shoppers?.futureMonth?.map((shopper, index) => (
                    <div className="previous-shoppers__item" key={index}>
                      <div className="previous-shoppers__month">{`${shopper?.month} - ${shopper?.year}`}</div>
                      <div className="previous-shoppers__name">{shopper?.shopperUsername}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="applications">
              {!selectedBundle && (
                <div className="applications__header table-row-background">
                  {/* <div className="applications__header-cell">Delete</div> */}
                  <div className="applications__header-cell" style={{}}>Shopper Name</div>
                  <div className="applications__header-cell">Date</div>
                  <div className="applications__header-cell">Time</div>
                  <div className="applications__header-cell">AirTasker?</div>
                  <div className="applications__header-cell">Issues</div>
                  <div className="applications__header-cell">Action</div>
                </div>)}


              {(!selectedBundle && appliedAllocation.length > 0) && appliedAllocation?.map((shopperApplied, index) => (
                <>
                  <div className="applications__row" key={index}>
                    {/* <div className="applications__cell">
                      <button className="delete-button">X</button>
                    </div> */}
                    <div className="applications__cell " style={{ cursor: "pointer" }}>
                      <span
                        className="shopper-badge table-row-background"
                        onClick={(e) => {
                          handleHover(e, index, shopperApplied)
                        }}
                      >
                        {shopperApplied.userId.firstName} {shopperApplied.userId.lastName}
                      </span>
                    </div>
                    <div
                      className="applications__cell"
                      style={{
                        background: "white",
                        textAlign: "center",
                        borderRadius: "5px",
                      }}
                    >
                      {new Date(shopperApplied.selectedVisitDate).toLocaleDateString("en-GB")}
                    </div>
                    <div className="applications__cell">{shopperApplied.selectedVisitTime.visitTimeInformation}</div>
                    <div className="applications__cell">
                      <Checkbox />
                    </div>
                    <div className="applications__cell">
                      <IconButton
                        size="small"
                        className="iconColor"
                        onClick={() => {
                          handleIconClick(shopperApplied)
                        }}
                      >
                        <Warning
                          sx={{
                            color: "red",
                            cursor: "pointer",
                          }}
                        />
                      </IconButton>
                    </div>
                    <div className="applications__cell applications__actions d-flex align-items-center gap-1">
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved")}
                      >
                        Approve
                      </Button>
                      <Button
                        className="action-button action-button--approve table-row-background"
                        onClick={() => { setOpenHoldReason(true) }}
                      >
                        Hold
                      </Button>
                    </div>
                  </div>

                  <Dialog open={OpenHoldReason} onClose={() => { setOpenHoldReason(false) }}>
                    <DialogContent>
                      <TextField
                        required

                        className='p-0'
                        sx={{
                          width: '300px',
                          ".MuiOutlinedInput-input ": {
                            padding: '10px'
                          },
                          ".MuiInputLabel-root": {
                            top: '-6px'
                          }
                        }}
                        value={reasonforhold}
                        onChange={(e) => { setreasonforhold(e.target.value) }}
                        id="outlined-required"
                        label="Reason"
                      />
                      <Button sx={{ color: 'white' }} className="d-block mt-2  mx-auto action-button action-button--approve table-row-background"
                        onClick={() => { (reasonforhold.length > 0) ? handleHoldAppliedAllocation(shopperApplied) : alert("Reason is required") }}>
                        Submit
                      </Button>
                    </DialogContent>
                  </Dialog>
                </>
              ))}
              {selectedBundle && groupappliedAllocation?.map((Card, index) => (
                <>
                  <Box className='border my-3 px-3  py-2' borderRadius='20px' >
                    <div style={{ borderBottom: '1px solid #a3a3a3' }} className="applications__cell applications__actions d-flex justify-content-between">
                      <Typography fontWeight='bold' variant="h6">{Card.userId} {Card.data[0].userId.firstName} {Card.data[0].userId.lastName}</Typography>
                      <Box className='d-flex' gap={2}>
                        <Button
                          className="action-button action-button--approve table-row-background"
                          onClick={() => handleUpdateBundleAppliedAllocation(appliedAllocation.bundleId, Card.userId, "approved")}
                        >
                          Approve
                        </Button>
                        <Button
                          className="action-button action-button--approve table-row-background"
                          onClick={() => {setOpenHoldReason(true); setholdId(Card.userId)}}
                        >
                          Hold
                        </Button>
                      </Box>
                    </div>
                    <div className="applications__header2 py-0 mt-2 table-row-background">
                      <div className="applications__header-cell text-center">Date</div>
                      <div className="applications__header-cell">Time</div>
                      <div className="applications__header-cell">AirTasker?</div>
                      <div className="applications__header-cell">Issues</div>
                    </div>

                    {Card.data.map((shopperApplied, index) => (
                      <div className="applications__row2" key={index}>
                        <div
                          className="applications__cell py-0 my-0"
                          style={{
                            background: "white",
                            textAlign: "center",
                            borderRadius: "5px",
                          }}
                        >
                          {new Date(shopperApplied.selectedVisitDate).toLocaleDateString("en-GB")}
                        </div>
                        <div className="applications__cell py-0 my-0">{shopperApplied.selectedVisitTime.visitTimeInformation}</div>
                        <div className="applications__cell py-0 my-0">
                          <Checkbox />
                        </div>
                        <div className="applications__cell py-0 my-0">
                          <IconButton
                            size="small"
                            className="iconColor"
                            onClick={() => {
                              handleIconClick(shopperApplied)
                            }}
                          >
                            <Warning
                              sx={{
                                color: "red",
                                cursor: "pointer",
                              }}
                            />
                          </IconButton>
                        </div>
                      </div>

                    ))}
                  <Dialog open={OpenHoldReason} onClose={() => { setOpenHoldReason(false) }}>
                    <DialogContent>
                      <TextField
                        required

                        className='p-0'
                        sx={{
                          width: '300px',
                          ".MuiOutlinedInput-input ": {
                            padding: '10px'
                          },
                          ".MuiInputLabel-root": {
                            top: '-6px'
                          }
                        }}
                        value={reasonforhold}
                        onChange={(e) => { setreasonforhold(e.target.value) }}
                        id="outlined-required"
                        label="Reason"
                      />
                      <Button sx={{ color: 'white' }} className="d-block mt-3 mx-auto action-button action-button--approve table-row-background"
                        onClick={() => { (reasonforhold.length > 0) ? handleHoldBundleAppliedAllocation(appliedAllocation.bundleId, holdId) : alert("Reason is requierd") }}>
                        Submit
                      </Button>
                    </DialogContent>
                  </Dialog>
                  </Box>
                </>


              ))}
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              pb: 1,
            }}
          >
            <Warning sx={{ color: "error.main" }} />
            <Typography variant="h6" component="span">
              Allocation Issues
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ ml: "auto" }} size="small">
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {issueList.length > 0 ? (
              <List dense>
                {issueList.map((issue, index) => (
                  <ListItem key={index} sx={{ px: 0 }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <Error sx={{ color: "error.main", fontSize: 20 }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={issue}
                      primaryTypographyProps={{
                        variant: "body2",
                        color: "text.primary",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 3,
                }}
              >
                <Typography variant="body1" color="success.main">
                  ✅ No issues found with the current allocation criteria.
                </Typography>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDialog} variant="contained" color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Updated Pagination - now uses totalCount from API */}

      </Box>
    </div>
  )
}
